var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0C7.16416 0 -0.00012207 7.16429 -0.00012207 16C-0.00012207 24.8357 7.16416 32 15.9999 32C24.8356 32 31.9999 24.8357 31.9999 16C31.9999 7.16429 24.8356 0 15.9999 0ZM22.9106 10.775L15.3892 21.2036C15.284 21.3503 15.1455 21.4699 14.9849 21.5523C14.8243 21.6348 14.6464 21.6778 14.466 21.6778C14.2854 21.6778 14.1076 21.6348 13.947 21.5523C13.7864 21.4699 13.6479 21.3503 13.5427 21.2036L9.08916 15.0321C8.95345 14.8429 9.08916 14.5786 9.32131 14.5786H10.9963C11.3606 14.5786 11.707 14.7536 11.9213 15.0536L14.4642 18.5821L20.0785 10.7964C20.2927 10.5 20.6356 10.3214 21.0034 10.3214H22.6784C22.9106 10.3214 23.0463 10.5857 22.9106 10.775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/iconCheckCircle.1c166859.svg";
export { ForwardRef as ReactComponent };